import type { ReactNode } from "react";
import type { ComponentDiagnostic } from "@swot/base-components";
import type { PermissionContext } from "@swot/swot-components";
import { CmtsAppShell } from "@modules/pages/cmtsAppShell.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function CmtsAppLayout(props: {
  runtime: CmtsHostRuntime;
  activePath?: string | undefined;
  permissionContext?: PermissionContext | null | undefined;
  diagnostics?: readonly ComponentDiagnostic[] | undefined;
  children: ReactNode;
}) {
  return (
    <CmtsAppShell
      activePath={props.activePath}
      diagnostics={props.diagnostics ?? props.runtime.diagnostics}
      permissionContext={props.permissionContext}
      runtime={props.runtime}
    >
      {props.children}
    </CmtsAppShell>
  );
}
